<template>
  <b-card :title="ocorrencia.titulo || '[Novo título]'">
    <b-row>
      <b-col
        cols="12"
        class="button-wrapper mb-1"
      >
        <span
          class="button btn w-100 btn-primary"
          @click="$refs.file.click()"
        >
          <input
            ref="file"
            type="file"
            accept="image/*"
            @change="uploadImage($event)"
          >
          Tirar Foto / Buscar Imagem
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <cropper
          ref="cropper"
          class="cropper"
          :src="image"
          :stencil-props="{
            handlers: {},
            movable: false,
            scalable: false,
          }"
          :stencil-size="{
            width: 480,
            height: 480,
          }"
          :resize-image="{
            adjustStencil: false,
          }"
          image-restriction="stencil"
        />
      </b-col>
    </b-row>
    <validation-observer ref="regras">
      <b-form @submit.prevent="onGravar">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Título">
              <validation-provider
                #default="{ errors }"
                name="Título"
                rules="required"
              >
                <b-form-input
                  v-model="ocorrencia.titulo"
                  label="Título"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Título"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Descrição da Ocorrência">
              <validation-provider
                #default="{ errors }"
                name="Descrição"
                rules="required"
              >
                <b-form-textarea
                  v-model="ocorrencia.descricao"
                  label="Descrição"
                  name="Descrição"
                  counter="10000"
                  rows="5"
                  maxlength="10000"
                  placeholder="Digite a descrição"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button
              class="w-100"
              variant="primary"
              type="submit"
            >
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BFormInput, BFormGroup, BForm, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  components: {
    BFormInput,
    BForm,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    Cropper,
  },
  data() {
    return {
      image: null,
      required,
      ocorrencia: {
        titulo: '',
        foto: null,
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.ocorrencia.id = this.$route.params.id
    }
  },
  methods: {
    cropImage() {
      if (!this.image) return null
      const result = this.$refs.cropper.getResult()
      return result.canvas.toDataURL('image/jpeg')
      // const newTab = window.open()
      // newTab.document.body.innerHTML = `<img src="${result.canvas.toDataURL('image/jpeg',)}"></img>`
    },
    uploadImage(event) {
      // Reference to the DOM input element
      const input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        const reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.image = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },
    onGravar() {
      this.$refs.regras.validate().then(result => {
        if (result) {
          const imageCropped = this.cropImage()
          this.ocorrencia.foto = imageCropped
          this.$store
            .dispatch('livroOcorrencia/saveOcorrencia', { ...this.ocorrencia })
            .then(res => {
              this.comentario = {}
              this.$toast.success('Ocorrência gravada com sucesso.')
              this.$router.push(`/ocorrencia/${res.data}`)
            })
            .catch(err => {
              this.showError(err)
            })
        }
      })
    },
    showError(err) {
      this.$toast.error(err.response ? err.response.data.error : err)
    },
    showSuccess(msg) {
      this.$toast.success(msg)
    },
  },
}
</script>

<style>
.example-cropper {
  border: solid 1px #eee;
  min-height: 300px;
  width: 100%;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  background: #24004d;
  cursor: pointer;
  transition: background 0.5s;
  font-family: Open Sans, Arial;
  margin: 0 10px;
}

.button:hover {
  background: #5a00c0;
}

.button input {
  display: none;
}

.cropper {
  max-height: 480px;
}
</style>
